import type { MarketUpdateStatusType } from 'app/shared/types/ApiResponseTypes';

export const toSubscriptionResult = ({ marketUpdateEnabled, streetAddress }: MarketUpdateStatusType) => {
  const { street, state, city, zip, unit, hasUnitLabel } = streetAddress;

  return {
    isSubscribed: marketUpdateEnabled,
    address: `${street} ${hasUnitLabel ? unit : ''}, ${city}, ${state} ${zip}`,
  };
};
